var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g2, _path14, _rect, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogotipo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 576,
    height: 526,
    viewBox: "0 0 576 526",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.221 383.656C364.792 383.656 447.131 302.977 447.131 203.454C447.131 103.931 364.792 23.2524 263.221 23.2524C161.651 23.2524 79.3116 103.931 79.3116 203.454C79.3116 302.977 161.651 383.656 263.221 383.656Z",
    fill: "#FF9B21"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M384.72 104.058C377.155 109.853 369.367 113.313 365.41 113.042C355.487 112.361 349.616 81.1193 355.053 67.5629C360.491 54.0064 397.704 42.5253 403.522 66.7315C405.542 75.1327 402.764 83.3626 397.86 90.4998L415.436 132.922L384.764 137.827L384.72 104.058Z",
    fill: "#D4A181"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.293 73.5422C375.077 70.4258 372.1 68.1325 368.538 67.094C355.084 69.4415 353.161 67.5273 351.999 60.2249C353.955 58.4798 361.265 54.8988 369.766 52.8609C373.977 51.0328 379.211 50.4129 384.52 51.49C390.954 52.0737 396.73 54.6233 400.051 60.5946C410.479 72.2005 406.27 86.691 398.443 92.6629C395.779 90.6078 393.418 88.581 391.287 86.6201C392.513 85.1443 393.121 83.2611 392.815 81.3342C392.211 77.5385 388.288 75.0106 384.054 75.6878C383.742 75.7376 383.438 75.8033 383.141 75.8839C383.706 80.66 385.476 96.8409 384.303 102.747C382.92 109.711 369.005 113.591 364.063 114.382C359.794 115.065 359.363 111.418 359.054 108.805C359.01 108.428 358.968 108.073 358.917 107.756C358.812 107.093 359.775 106.94 360.863 106.768C362.275 106.545 363.899 106.288 363.668 104.836C363.416 103.253 360.782 102.429 358.425 101.691C356.954 101.231 355.591 100.805 354.982 100.249C353.06 98.4954 352.09 95.8708 354.507 95.4843C355.828 95.273 357.749 95.6658 360.06 96.1383C363.55 96.8517 367.928 97.7468 372.474 97.0199C379.983 95.819 378.314 73.8174 378.293 73.5422Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.392 229.28L402.207 355.073L388.571 449.239L372.11 449.711L382.094 230.751L433.392 229.28Z",
    fill: "#997659"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M449.063 228.831C448.543 293.73 450.546 329.062 451.264 334.937C451.983 340.811 456.238 380.17 479.342 448.616L462.221 449.107C432.368 383.665 421.465 344.497 418.008 335.89C414.552 327.283 404.058 292.195 388.431 230.569L449.063 228.831Z",
    fill: "#B28B67"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.141 229.259C426.338 272.46 412.674 341.456 393.149 436.245L369.073 436.935C364.442 340.35 370.13 276.531 381.891 230.757L434.141 229.259Z",
    fill: "#C8D9E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M449.184 228.827C448.715 293.725 456.775 357.417 478.204 434.817L452.516 435.553C422.641 371.101 400.733 308.121 384.745 230.675L449.184 228.827Z",
    fill: "#C8D9E9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M482.161 461.398L480.863 446.87C480.805 446.226 480.161 445.804 479.533 445.959C471.342 447.976 459.908 444.226 459.908 444.226C448.746 452.947 432.431 457.287 426.595 458.629C425.434 458.895 424.722 460.091 425.07 461.23L426.513 465.962L460.521 464.987L480.359 464.418L482.161 461.398Z",
    fill: "#191847"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.683 463.963L391.385 449.435C391.327 448.791 390.683 448.369 390.056 448.524C381.864 450.541 370.431 446.791 370.431 446.791C359.269 455.512 342.953 459.852 337.117 461.194C335.957 461.46 335.245 462.656 335.592 463.795L337.035 468.527L371.043 467.552L390.882 466.984L392.683 463.963Z",
    fill: "#191847"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.447 280.23L343.954 245.045L355.454 265.877L324.011 287.943C316.613 302.775 312.148 309.179 310.615 307.155C309.322 305.448 309.776 303.585 310.195 301.868C310.52 300.531 310.825 299.283 310.264 298.268C308.985 295.949 302.508 297.251 296.425 298.793C290.342 300.334 291.586 296.844 292.801 295.025C298.344 289.619 305.559 284.688 314.447 280.23ZM505.319 303.386C500.826 296.372 477.225 224.782 477.225 224.782L454.534 228.518C454.534 228.518 489.322 304.22 491.84 308.79C495.111 314.726 493 324.449 491.569 331.041C491.348 332.061 491.142 333.006 490.976 333.851C494.772 335.108 496.062 332.648 497.423 330.056C498.96 327.127 500.586 324.028 506.012 325.922C508.108 326.653 510.135 327.59 512.114 328.506C518.953 331.669 525.235 334.574 531.926 327.858C532.986 326.793 533.744 323.301 530.089 321.252C520.982 316.146 507.516 306.815 505.319 303.386Z",
    fill: "#D4A181"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.385 124.139L383.661 123.765C354.897 164.413 352.298 234.082 315.771 276.61L328.641 289.812C400.921 267.266 404.999 182.141 393.385 124.139Z",
    fill: "#E87613"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M458.271 255.102C458.271 255.102 401.754 264.14 375.125 268.399C371.326 269.007 370.93 262.504 370.919 259.192C370.785 220.974 388.552 176.911 379.339 123.951L402.56 115.736C428.86 149.715 443.678 194.359 458.271 255.102Z",
    fill: "#DDE3E9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M472.243 280.181C477.798 290.034 483.049 298.567 487.72 305.019L505.552 302.168C494.904 229.627 461.75 177.802 436.266 147.431C440.566 146.37 444.135 143.614 445.715 137.984C451.277 118.163 446.347 108.528 436.399 106.693C430.929 105.684 426.302 107.71 420.763 110.135C416.23 112.12 411.087 114.371 404.372 115.446C404.37 115.447 404.368 115.447 404.366 115.447C403.715 115.551 403.132 115.697 402.611 115.88L394.745 117.682C394.745 117.682 384.617 250.37 406.524 290.691L472.243 280.181Z",
    fill: "#F6703D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M472.243 280.181C464.955 267.253 457.143 252.052 449.429 236.296C450.795 254.787 450.976 273.549 447.68 284.109L472.243 280.181Z",
    fill: "black",
    fillOpacity: 0.1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_125_1097)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200.697,
    height: 404.289,
    rx: 36.45,
    transform: "matrix(0.999422 -0.0339845 0.0358391 0.999358 43.3292 66.9678)",
    fill: "#202020"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M210.639 69.8743C224.051 69.4127 235.31 79.9109 235.785 93.323L247.751 430.988C248.226 444.4 237.738 455.647 224.326 456.108L90.3993 460.717C76.9867 461.179 65.7285 450.68 65.2532 437.267L53.2875 99.6026C52.8124 86.1907 63.2998 74.9437 76.7123 74.4822L94.7817 73.86L94.7875 74.023C95.057 81.6232 101.437 87.5724 109.037 87.311L179.779 84.8788C187.379 84.6174 193.322 78.2442 193.053 70.6441L193.047 70.4791L210.639 69.8743Z",
    fill: "#C6CACD",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_125_1097",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 83,
    width: 250,
    height: 376
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 236.693,
    height: 366.954,
    transform: "matrix(0.999402 -0.034577 0.035225 0.999379 52.1172 92.0044)",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_125_1097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8105 394.204C51.8105 394.204 90.2299 413.921 119.853 420.124C149.476 426.326 178.595 414.447 178.595 414.447C178.595 414.447 141.114 394.618 115.259 389.204C89.4045 383.791 51.8105 394.204 51.8105 394.204Z",
    fill: "#FFD4C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.101 435.789C140.922 435.348 140.791 434.882 140.713 434.391C139.105 424.219 102.732 310.502 100.931 290.727L166.543 304.465C167.913 319.501 168.673 412.214 167.657 430.468C170.466 460.184 169.154 554.245 170.124 560.983C171.144 568.072 155.94 572.05 154.027 563.198C150.984 549.112 144.8 510.605 143.316 487.574C141.926 465.981 141.169 446.659 141.101 435.789Z",
    fill: "#D4A181"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.7465 436.944C56.6818 437.951 -43.3438 429.451 -50.4347 429.918C-57.7289 430.399 -60.7687 415.267 -51.6167 414.044C-37.0544 412.097 2.61262 408.859 26.1905 409.085C45.155 409.267 62.385 409.782 73.8979 410.382C79.5572 379.584 91.0894 305.244 97.3393 289.975L155.394 302.131C149.401 316.773 102.534 422.951 95.877 433.168C93.6693 436.851 89.2572 437.759 84.7465 436.944Z",
    fill: "#D4A181"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.5269 290.015C97.5269 290.015 138.218 287.312 170.145 305.219C170.44 342.322 186.704 360.429 178.374 415.474C135.751 426.143 95.0251 384.049 51.3676 394.015C45.5387 366.068 74.7119 307.812 97.5269 290.015Z",
    fill: "#FFD4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.05 135.43C195.474 112.357 226.554 129.378 228.553 143.623C230.553 157.867 218.575 187.897 209.487 187.062C205.862 186.728 199.585 182.117 194.008 175.231L186.741 208.65L160.149 199.132L185.067 159.813C182.177 152.004 181.433 143.438 185.05 135.43Z",
    fill: "#D4A181"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.865 126.852C219.641 124.445 214.505 122.182 212.192 121.642C214.571 119.075 216.317 115.891 217.121 112.47C217.901 109.146 217.48 105.926 217.213 102.616C217.09 101.09 216.884 99.5418 216.228 98.1735C215.56 96.7796 214.486 95.6329 213.218 94.8151C211.92 93.9782 210.425 93.4742 208.893 93.2635C208.215 93.1703 207.544 93.2554 206.868 93.1942C206.176 93.1315 206.016 92.6271 205.704 92.0663C204.953 90.715 203.507 89.6633 202.172 88.994C200.673 88.2432 198.958 87.8968 197.272 87.876C195.63 87.8559 193.931 88.1689 192.439 88.9774C191.775 89.3372 191.127 89.7855 190.605 90.3496C190.391 90.5811 190.313 90.7356 190.004 90.7379C189.718 90.7401 189.423 90.6375 189.131 90.6324C186.306 90.5825 183.443 91.7505 181.354 93.8183C180.136 95.0247 178.868 97.4627 177.897 100.357C176.926 103.251 176.751 111.646 178.164 115.237C179.426 118.442 182.009 121.184 184.816 122.984C181.921 124.577 179.492 126.994 177.398 129.587C175.124 132.403 173.218 135.493 171.713 138.797C170.283 141.937 169 145.339 168.589 148.766C168.205 151.971 168.824 154.934 170.785 157.375C171.683 158.493 172.734 159.468 173.809 160.4C174.868 161.318 175.936 162.224 177.132 162.955C179.394 164.337 182.248 165.26 184.855 163.99C185.795 163.531 186.869 162.918 187.682 162.238C187.975 161.994 188.157 161.831 188.052 161.452C187.926 160.998 187.608 160.571 187.379 160.17C186.073 157.879 185.69 155.309 186.339 152.65C186.996 149.951 188.931 146.857 191.873 146.63C195.504 146.349 198.341 149.179 200.557 151.663C203.268 147.939 207.065 145.072 211.556 144.526C216.525 143.922 221.424 145.397 226.398 145.134C227.694 145.065 229.035 144.94 230.215 144.278C230.709 144.001 231.306 143.626 231.64 143.146C232.079 142.515 231.845 141.771 231.698 141.104C230.922 137.569 226.089 129.259 222.865 126.852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.721 292.706L220.05 284.303L221.53 307.222L263.37 304.478C278.813 311.143 286.654 313.233 286.894 310.749C287.096 308.654 285.595 307.522 284.212 306.48C283.134 305.667 282.129 304.909 282.057 303.793C281.892 301.242 288.626 298.218 295.137 295.619C301.648 293.02 298.473 291.144 296.295 290.517C288.039 289.852 278.515 290.581 267.721 292.706ZM8.964 333.063C14.6045 327.322 73.2441 248.976 73.2441 248.976L98.5196 257.159C98.5196 257.159 26.1694 336.88 22.9373 340.698C18.7387 345.658 19.9372 355.197 20.7499 361.665C20.8757 362.666 20.9921 363.593 21.078 364.419C16.8334 364.88 15.7121 362.324 14.5299 359.629C13.1947 356.585 11.7819 353.364 5.7034 354.115C3.35499 354.405 1.05936 354.901 -1.18345 355.387C-8.93056 357.063 -16.0475 358.603 -22.5329 351.021C-23.5611 349.819 -23.9914 346.394 -19.8106 345.16C-9.39466 342.088 6.2065 335.87 8.964 333.063Z",
    fill: "#D4A181"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.89 191.421L188.272 199.065C178.669 244.47 196.103 280.661 258.711 290.307L247.968 349.297C189.987 338.657 148.511 300.949 158.291 237.874C160.823 221.546 164.108 204.761 168.89 191.421Z",
    fill: "#DD3322"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1915 322.801C53.9591 254.504 101.571 207.545 159.028 181.924L160.93 182.532L160.994 182.553L161.004 182.576L188.77 199C176.941 234.814 176.125 264.139 175.34 292.332C175.002 304.507 174.669 316.471 173.457 328.655L92.3782 302.74C86.933 315.403 81.8088 328.569 76.9008 342.205L16.1915 322.801Z",
    fill: "#DD3322"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.3782 302.74C103.464 276.959 115.881 253.265 130.514 231.939C120.701 256.611 109.978 287.679 108.857 308.007L92.3782 302.74Z",
    fill: "black",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_125_1097",
    x: 0.611694,
    y: 49.3645,
    width: 280.505,
    height: 476.415,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: 22
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_125_1097"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_125_1097",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotipo);
export default __webpack_public_path__ + "static/media/Logotipo.afecb791ffc2b61b5cc8ec68f1a5317c.svg";
export { ForwardRef as ReactComponent };